export default __webpack_public_path__ + "static/mangobarfi-70bf80729d98e9986694afd99a7609e2.png";